export default {
	API_URL: process.env.VUE_APP_CHAT_BOT_API_URL,
	BROADCAST_KEY: process.env.VUE_APP_BOROADCAST_KEY,
}
